import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Input, Modal } from "rsuite";
import { Button, FileUploader } from "../../components";
import { getLocalized } from "../../redux/localization";
import { UploadDocument, UploadDocumentInput } from "../../redux/offer/types";
import { useHistory } from "react-router-dom";
import garageCart from "../../redux/garageCart";
import { useState } from "react";
import Checkmark from "react-typescript-checkmark";
import { uploadDocument } from "../../redux/offer";
import { BsArrowRight } from "react-icons/bs";
import { ButtonType } from "../../components/button";
import CustomLoader from "../../components/loader";

const DocumentForm = ({ documents }: { documents: UploadDocumentInput[] }) => {
  const localize = useSelector(getLocalized);
  const [uploaded, setUploaded] = useState(false);
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const submit = async (values: UploadDocument) => {
    setLoader(true);
    dispatch(
      uploadDocument({
        payload: {
          onSuccess: () => {
            setLoader(false);
            setUploaded(true);
            setLoader(false);
          },
          onError: () => {
            setLoader(false);
          },
        },
        url: "api/offer/demandeddocument/uploadDocuments",
        body: values,
      })
    );
  };
  const handleClose = () => {
    dispatch(garageCart.actions.clearGarage());
    history.push("/");
  };
  return (
    <div>
      {loader && <CustomLoader />}
      <Modal
        className="offer-end-modal"
        open={uploaded}
        size="xs"
        onClose={() => {
          dispatch(garageCart.actions.clearGarage());
          setTimeout(() => {
            window.location.replace("/");
          }, 1000);
          return handleClose();
        }}
      >
        <Modal.Header></Modal.Header>
        <div>
          <Modal.Body style={{ padding: "10px 20px" }}>
            <div style={{ marginBlock: 10 }}>
              <Checkmark
                backgroundColor="rgb(255, 68, 54)"
                animationDuration={0.8}
                explosion={1.2}
              />
            </div>
            <div style={{ textAlign: "center" }} className="text-font">
              Finansal değerlendirme sürecini başlatabilmek için tüm evraklar
              tarafımıza ulaşmıştır. Finans uzmanlarımız ek döküman /
              dökümanlara ihtiyaç duymaları halinde sizinle temasa geçecektir.
              Değerlendirme sürecimiz 2 iş günü içinde sonuçlandırılmaktadır.
              <br />
              Teşekkür Ederiz
            </div>
          </Modal.Body>
        </div>
      </Modal>
      {!uploaded && (
        <Formik
          initialValues={{
            Documents: documents,
          }}
          onSubmit={submit}
        >
          {({ handleSubmit, values, setFieldValue, touched }) => {
            return (
              <div
                className="garage-detail-card"
                style={{
                  height: "100%",
                  padding: 5,
                  marginBlock: "0px 20px",
                }}
              >
                <h5
                  style={{ textAlign: "center", marginBlock: 20 }}
                  className="header-font"
                >
                  {localize.getString("document_form")}
                </h5>
                <div className="document-form">
                  {documents.map((documentItem, i) => (
                    <div
                      className="document-input"
                      key={i}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        gap: 10,
                        marginBlockEnd: 5,
                        padding: "5px",
                        width: "50%",
                      }}
                    >
                      <div>
                        <Input
                          style={{ color: "black", fontSize: 16 }}
                          disabled
                          className="input custom-font-family"
                          value={documentItem.DocumentTypeName}
                        />
                      </div>
                      <div>
                        {/* <Uploader
                      action="//jsonplaceholder.typicode.com/posts/"
                      onUpload={(file: any) => {
                      }}
                    /> */}
                        <FileUploader
                          buttonText={localize.getString("select_file")}
                          onValueChanged={(values: any) => {
                            setFieldValue(
                              `Documents[${i}.DocumentFile]`,
                              values[0]
                            );
                            setFieldValue(
                              `Documents[${i}.Id]`,
                              documentItem.Id
                            );
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-End" }}>
                  <Button
                    buttonType={ButtonType.newColored}
                    icon={<BsArrowRight />}
                    style={{
                      fontSize: 22,
                    }}
                    title={"GÖNDER"}
                    onClick={handleSubmit}
                  />
                </div>
              </div>
            );
          }}
        </Formik>
      )}
      <Divider />
    </div>
  );
};
export default DocumentForm;
